import { LoggedInUserType } from "../types/LoggedInUserType";

export default function getUserTypeText(userType: LoggedInUserType) {
    switch (userType) {
        case LoggedInUserType.DOCUMENT_COLLECTOR:
            return "Vessel Contact";
        case LoggedInUserType.IDWAL_ADMIN:
            return "Idwal";
        case LoggedInUserType.IDWAL_SURVEYOR:
            return "Surveyor";
        default:
            return "Unknown";
    }
}

export function userIsDocCollector(state: any) {
    return state.portal.userType === LoggedInUserType.DOCUMENT_COLLECTOR;
}

export function userIsInAppGroup(state: any): boolean {
    const user = state.portal.user;
    if (!user?.signInUserSession) return false;
    const groups: string[] = user.signInUserSession.accessToken.payload["cognito:groups"] ?? [];
    const appGroup = process.env.REACT_APP_IDWAL_INSPECT_APP_GROUP;
    if (!appGroup) return false;
    return groups.includes(appGroup);
}